// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2XbBy","footer":"ModalInfo_footer__38RbJ"};